import { jurisdictionName } from '~/lib/laws/jurisdiction'

/**
 * `jurisdictionName` bound to the UI locale and the translated label of the global corpus, so a
 * component names a jurisdiction in the language its user reads (MAR-948 wave 3).
 */
export function useJurisdictionName() {
  const { t, locale } = useI18n()
  return (code: string | null | undefined): string =>
    jurisdictionName(code, locale.value, t('laws.jurisdictionGlobal'))
}
